import React from 'react'
import { CircularProgress } from '@mui/material';

function LoadingProtal() {
    return (
        <div className="container">
            <div className='row'>
                <div className='col-md-12 text-center'>
                    <img src='/images/ghelp-logo.png' style={{width:"30%"}} />
                </div>
                <div className="col-md-12 text-center mt-5">
                    <CircularProgress/>
                </div>
                <div className="col-md-12 text-center">
                    <p>Please Scan QR Code </p>
                </div>
            </div>
        </div>
    )
}

export default LoadingProtal